import { AxiosInstance } from 'axios'
import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import ForecastProvider from '@/utilities/weather/services/openWeatherApi/ForecastProvider'
import HistoryWeatherProvider from '@/utilities/weather/services/openWeatherApi/HistoryWeatherProvider'
import WeatherValidateInterface from '@/utilities/weather/services/interfaces/WeatherValidateInterface'
import AbstractWeatherService from '@/utilities/weather/services/abstracts/AbstractWeatherService'

export default class OpenWeatherApi extends AbstractWeatherService implements WeatherValidateInterface {
  private readonly apiUrl: string = 'https://api.openweathermap.org/data/2.5'
  private readonly currentDate: Dayjs
  private readonly min: Dayjs
  private readonly max: Dayjs

  constructor(apiKey: string, httpClient: AxiosInstance, currentDate: Dayjs) {
    super(apiKey, httpClient)

    this.currentDate = currentDate

    this.min = this.currentDate.clone().subtract(5, 'days')
    this.max = this.currentDate.clone().add(7, 'days')
  }

  async getInfo(coordinate: CoordinateType, date: Dayjs): Promise<WeatherType> {
    if (!this.isValid(date)) {
      throw new Error('Date is not valid')
    }

    if (this.currentDate.isAfter(date, 'date')) {
      return new HistoryWeatherProvider(this.apiKey, this.httpClient, this.apiUrl).getInfo(coordinate, date)
    }

    return new ForecastProvider(this.apiKey, this.httpClient, this.apiUrl).getInfo(coordinate, date)
  }

  isValid(date: Dayjs): boolean {
    const min = this.getMin()
    const max = this.getMax()

    return (date.isAfter(min, 'day') || date.isSame(min, 'day')) && (date.isBefore(max, 'day') || date.isSame(max, 'day'))
  }

  getMin(): string {
    return this.min.format('YYYY-MM-DD')
  }

  getMax(): string {
    return this.max.format('YYYY-MM-DD')
  }
}
